module.exports = __webpack_public_path__ + "img/shine-bg.21d651eb.png";